<div class="mv-fonts-lato router">
    <mv-popin-nicepresent></mv-popin-nicepresent>
    <mv-popin-msgdestination></mv-popin-msgdestination>
    <mv-contract-gcv></mv-contract-gcv>
    <mv-loader message="Chargement..." show="{{ loaderservice.loading$ | async }}"></mv-loader>
    <router-outlet> </router-outlet>
</div>
